import { apiService } from '../../shared/services/apiService';
import { ChallengeSignUpEntityData } from '../interfaces/ChallengeSignUpEntityData';

export const challengeSignUpService = {
  async getChallengeSignUpEntityData(
    challengeId: number,
  ): Promise<ChallengeSignUpEntityData> {
    const response = await apiService.get(
      `/api/public/challenge/${challengeId}/entity-data`,
    );

    return response.data;
  },

  async setNickname(participantId: number, nickname: string): Promise<void> {
    await apiService.post(`/api/challenge/participant/${participantId}/nickname`, {
      nickname,
    });
  },

  async setDivision(participantId: number, divisionId: number): Promise<void> {
    await apiService.post(
      `/api/challenge/participant/${participantId}/division/${divisionId}`,
    );
  },
};
